import React from 'react';
import styled from 'styled-components';
import SiteLayout from '../components/Layout/SiteLayout';
import Link from '../components/Link';
import horizontallyCenteredSection from '../components/styles/horizontallyCenteredSection';

export default function IndexPage(props) {
  const LegalStyles = styled.section`
    width: 100%;
    ${horizontallyCenteredSection}
    display: inline-block;
    color: var(--color-white);
    background-color: var(--color-grey-1);
    padding-top: 2.5rem;
    padding-bottom: 5rem;
    word-break: break-word;
  `;

  return (
    <SiteLayout {...props} pageClassNames="index">
      <LegalStyles>
        <h1>Legal warning</h1>

        <h2>Legal notice and terms of use</h2>

        <p>
          This document is intended to guarantee the security of your data,
          complying with the obligations set forth in Law 34/2002, of July 11,
          on Services of the Information Society and Electronic Commerce
          (LSSICE), as well as inform you of the conditions of use of this
          website.
        </p>

        <p>
          When browsing this website you assume the role of &quot;USER&quot;,
          having to comply at all times with the legal provisions that may be
          applicable and those provided in this document.
        </p>

        <h2>Identification data</h2>

        <p>
          This website is owned by &quot;ARTEMA CORP, S.L.&quot; (hereinafter
          &quot;ARTEMA CORP&quot;). If you want to know our tax data write to
          hello@artemacorp.com indicating the reasons for the request.
        </p>

        <h2>Goal</h2>

        <p>
          By using this website, ARTEMA CORP offers the USER the possibility of
          accessing information of various kinds about our products.
        </p>

        <p>
          ARTEMA CORP reserves the right to modify the configuration,
          presentation and content of the website and corresponding Social
          Network profiles, without there being an obligation to pre-notify or
          inform the USER of said obligations, understanding as sufficient with
          the publication on the website of ARTEMA CORP.
        </p>

        <h2>Privacy and data processing</h2>

        <p>
          When accessing certain content or service it is necessary to provide
          personal data, the USER will guarantee its truthfulness, accuracy,
          authenticity and validity. ARTEMA CORP will give said data the
          automated treatment that is necessary according to its nature or
          purpose, in the terms indicated in the &quot;Privacy Policy&quot;.
        </p>

        <h2>Industrial and intellectual property</h2>

        <p>
          This website and the different elements that make it up, as well as
          the Social Network profiles managed by ARTEMA CORP, such as computer
          applications, distinctive signs, trade names, texts, photographs,
          logos or graphic designs, among others, are subject to intellectual
          and industrial property rights of which ARTEMA CORP is the exclusive
          owner.
        </p>

        <p>
          Any use not legally permitted and / or not expressly authorized in
          writing by ARTEMA CORP will be considered a serious breach of
          industrial and intellectual property rights.
        </p>

        <p>
          The USER undertakes to respect the Intellectual and Industrial
          Property rights owned by ARTEMA CORP. In no case does access to the
          website imply any type of waiver, transmission, license or total or
          partial transfer of said rights, unless expressly stated otherwise.
        </p>

        <p>USER obligations and responsibilities</p>

        <p>
          The USER undertakes to make correct use of the website and its
          contents, in accordance with the Law and these General Conditions of
          Use.
        </p>

        <p>
          By way of example and not limitation, the USER agrees not to transmit,
          disseminate or make available to third parties, data, content,
          information, messages, graphics, recordings or any other kind of
          material that involves:
        </p>

        <ul>
          <li>
            An unauthorized or fraudulent use of the website and the content
            provided on it for illegal purposes or effects, harmful to the
            rights and interests of ARTEMA CORP or third parties or those that,
            in any other way, may damage, disable, overload , deteriorate or
            prevent the normal use of services or documents, files and all kinds
            of content stored on any computer.
          </li>
          <li>
            Access or attempt to access restricted resources or areas of the
            website, without complying with the conditions required for such
            access.
          </li>
          <li>
            Causing damage to the systems of the ARTEMA CORP website or third
            parties.
          </li>
          <li>
            Introduction or dissemination on the network of computer viruses or
            any other physical or logical systems that are likely to cause
            damage to ARTEMA CORP or to third parties.
          </li>
          <li>
            Access, use and / or manipulation of the data of ARTEMA CORP or
            third parties.
          </li>
          <li>
            Reproduction or copying, distribution, transformation or
            modification of content, unless you have the corresponding
            authorization from ARTEMA CORP or it is legally permitted.
          </li>
          <li>
            Suppression, concealment or manipulation of notes on intellectual or
            industrial property rights.
          </li>
          <li>
            Induction, incitement or promotion of criminal, denigratory,
            defamatory, violent actions or, in general, contrary to the law,
            morals, generally accepted good customs or public order.
          </li>
          <li>
            Induction, incitement or promotion of discriminatory attitudes based
            on sex, race, religion, beliefs, age or cognition.
          </li>
        </ul>

        <h2>Exclusion of guarantees and responsibilities</h2>

        <p>
          ARTEMA CORP is not responsible for damages of any nature that may be
          caused, by way of example, due to the lack of availability or
          continuity of the website, its infallibility or the correct display of
          its contents. ARTEMA CORP is not responsible for the decisions that
          may be taken as a result of access to the content or information
          offered.
        </p>

        <p>
          ARTEMA CORP excludes any liability for damages of any kind that may be
          due to the misuse of the services freely available and used by the
          USER of the website. Likewise, it is exonerated from any
          responsibility for the content and information that may be received as
          a result of the data collection forms, being the same only for the
          general information of ARTEMA CORP products, subscription to its
          Newsletter, or provision of the consultation services and doubts. On
          the other hand, in case of causing damages due to an illicit or
          incorrect use of said services, the USER may be claimed for the
          damages caused.
        </p>

        <p>
          The USER will hold ARTEMA CORP harmless from any damages arising from
          claims, actions or demands of third parties as a result of their
          access to or use of the website.
        </p>

        <h2>Links</h2>

        <p>
          The USER is granted a limited, revocable and non-exclusive right to
          create links to the main page of the ARTEMA CORP website or the
          profiles on Social Networks managed by it, exclusively for private and
          non-commercial use.
        </p>

        <p>
          These links (i) may not falsify your relationship or affirm that such
          a link has been authorized; (ii) may not establish any false,
          inaccurate or incorrect statement on the website, or on its contents.
          (iii) may not include content that may be considered in bad taste,
          obscene, offensive, controversial, that incites violence or
          discrimination based on sex, race or religion, contrary to public
          order or illegal; (iv) You may not link to any page other than the
          ARTEMA CORP website or their respective profiles on Social Networks.
        </p>

        <p>
          ARTEMA CORP may request, at any time, to remove any link to the Web
          Space, after which it must immediately proceed to its removal.
        </p>

        <h2>Privacy Policy</h2>

        <p>
          In accordance with the provisions of the General Regulation (EU) on
          Data Protection, and LO 3/2018, of December 5, Protection of Personal
          Data and guarantee of digital rights, by accepting this Privacy Policy
          on USER gives his informed, express, free and unequivocal consent so
          that the personal data he provides through the ARTEMA CORP website
          will be used only for the detailed use that is reported in this
          Privacy Policy.
        </p>

        <p>
          Accordingly, ARTEMA CORP, responsible for the website, informs the
          USER that the personal data that the latter may send will be
          incorporated into a file owned by ARTEMA CORP, to which the
          organizational and technical security measures required by the Law, in
          order to respond to the inquiries and requests of the USER, as well
          as, if the USER had consented to do so, to send commercial information
          by telematic means about contents or products of ARTEMA CORP.
        </p>

        <p>
          In case the USER has expressly consented to the sending of commercial
          communications, ARTEMA CORP informs that they may unsubscribe from
          these communications at any time, following the indications that
          appear at the end of all our emails.
        </p>

        <p>
          Likewise, the personal data that may be provided may be communicated
          to the Tax Authorities, Control Authorities in matters of data
          protection (eg: the Spanish Data Protection Agency) to the State
          Security Forces and Bodies, Judges and Courts if required or
          necessary.
        </p>

        <Link to="/cookies">
          <h2>Cookies policy (link)</h2>
        </Link>

        <h2>Modification of these conditions</h2>

        <p>
          ARTEMA CORP may modify the conditions determined here at any time, and
          they must be duly published in this section.
        </p>

        <h2>Claims and doubts</h2>

        <p>
          The USER can exercise their rights of access, rectification,
          cancellation and opposition of their data by email to
          hello@artemacorp.com.
        </p>

        <h2>Dispute resolution</h2>

        <p>
          These General Conditions of Use, as well as the use of the website,
          will be governed by Spanish legislation. For the resolution of any
          controversy, the parties will submit to the Courts and Tribunals of
          the city of Barcelona, ​​unless the applicable Law provides otherwise.
        </p>

        <p>
          In the event that any stipulation of these General Conditions of Use
          is unenforceable or null by virtue of the applicable legislation or as
          a consequence of a judicial or administrative resolution, said
          unenforceability or nullity will not make these General Conditions of
          Use unenforceable or null as a whole. In such cases, ARTEMA CORP will
          proceed to modify or replace said stipulation with another that is
          valid and enforceable and that, as far as possible, achieves the
          objective and claim reflected in the original stipulation.
        </p>

        <h2>Annexed</h2>
        <h3>Newsletter</h3>
        <p>
          ARTEMA CORP uses Mailchimp as its marketing platform for its
          newsletter. By subscribing, you acknowledge that your information will
          be transferred to Mailchimp for processing.{' '}
          <a
            href="https://mailchimp.com/legal/"
            target="_blank"
            rel="noreferrer"
          >
            Learn more about Mailchimp&apos;s privacy practices here.
          </a>
        </p>
        <p>
          ARTEMA CORP will only use your email to send you news of its products,
          never will transfer your personal data to thirparties or for other
          commercial pourposes.
        </p>

        <br />
        <small>Last update: May 27th, 2021.</small>
      </LegalStyles>
    </SiteLayout>
  );
}
